(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8017],{

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 3319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Os": function() { return /* binding */ AHeading; },
/* harmony export */   "V": function() { return /* binding */ CHeading; },
/* harmony export */   "Zg": function() { return /* binding */ BHeading; },
/* harmony export */   "ac": function() { return /* binding */ DHeading; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var AHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__AHeading",
  componentId: "sc-i66uaa-0"
})(["font-size:28px;font-weight:700;line-height:1.2;color:", ";border-bottom:1px solid ", ";padding-bottom:22px;margin-bottom:50px;@media screen and (max-width:1047px){font-size:19px;padding-bottom:10px;margin-bottom:30px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey);
var BHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "Heading__BHeading",
  componentId: "sc-i66uaa-1"
})(["font-size:24px;font-weight:700;line-height:140%;color:", ";margin-bottom:36px;@media screen and (max-width:1047px){font-size:20px;line-height:130%;margin-bottom:26px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var CHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Heading__CHeading",
  componentId: "sc-i66uaa-2"
})(["font-size:18px;font-weight:700;line-height:140%;margin-bottom:20px;@media screen and (max-width:1047px){font-size:16px;line-height:130%;margin-bottom:18px;}"]);
var DHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__DHeading",
  componentId: "sc-i66uaa-3"
})(["font-size:32px;font-weight:700;line-height:100%;color:", ";@media screen and (max-width:1047px){font-size:24px;line-height:130%;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 82319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/utils/enroutes.ts
var enroutes = __webpack_require__(9058);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
// EXTERNAL MODULE: ./src/components/elements/SpAccordion/index.tsx
var SpAccordion = __webpack_require__(13168);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enlayouts/SiteMap/IrSiteMapLink/IrSiteMap.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var SiteLink = function SiteLink(_ref) {
  var name = _ref.name,
      path = _ref.path,
      newWindow = _ref.newWindow;

  var link = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
    href: path,
    target: newWindow ? '_blank' : undefined,
    rel: newWindow ? 'noopener noreferrer' : undefined,
    children: name
  });

  if (path.endsWith('/ir/financial/chart/')) return link;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: path,
    passHref: true,
    children: link
  });
};

var IrSiteMap = function IrSiteMap(_ref2) {
  var parent = _ref2.parent,
      subdirectories = _ref2.subdirectories,
      _ref2$isLast = _ref2.isLast,
      isLast = _ref2$isLast === void 0 ? false : _ref2$isLast;

  if (isLast) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SpAccordion/* SpAccordion */.k, {
      title: parent.name,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FullBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ParentName, {
          children: parent.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PcLine, {
          color: "grey",
          weight: 1,
          direction: "horizon"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubdirectoryList, {
          direction: "row",
          children: subdirectories.map(function (site) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiteLink, _objectSpread({}, site))
            }, site.path);
          })
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpAccordion/* SpAccordion */.k, {
    title: parent.name,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ParentName, {
        children: parent.path ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: parent.path,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
            children: parent.name
          })
        }) : parent.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 0,
          pc: 14
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PcLine, {
        color: "grey",
        weight: 1,
        direction: "horizon"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 0,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubdirectoryList, {
        direction: "column",
        children: subdirectories.map(function (site) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiteLink, _objectSpread({}, site))
          }, site.name);
        })
      })]
    })
  });
};
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__Box",
  componentId: "sc-pz1tvd-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;padding:26px 20px 32px;@media screen and (max-width:1047px){width:100%;padding:0;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var FullBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__FullBox",
  componentId: "sc-pz1tvd-1"
})(["width:1040px;padding:26px 20px 32px;background:", ";border-radius:8px;display:flex;justify-content:space-between;align-items:center;@media screen and (max-width:1047px){display:block;width:100%;padding:0;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var PcLine = (0,styled_components_browser_esm/* default */.ZP)(Line/* Line */.x).withConfig({
  displayName: "IrSiteMap__PcLine",
  componentId: "sc-pz1tvd-2"
})(["@media screen and (max-width:1047px){display:none;}"]);
var ParentName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__ParentName",
  componentId: "sc-pz1tvd-3"
})(["font-size:20px;font-weight:700;line-height:120%;@media screen and (max-width:1047px){display:none;}"]);
var SubdirectoryList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "IrSiteMap__SubdirectoryList",
  componentId: "sc-pz1tvd-4"
})(["display:flex;row-gap:16px;column-gap:50px;flex-direction:", ";", " > li{font-size:16px;line-height:120%;}@media screen and (max-width:1047px){gap:14px;flex-direction:column;> li{font-size:14px;}}"], function (_ref3) {
  var direction = _ref3.direction;
  return direction;
}, function (_ref4) {
  var direction = _ref4.direction;
  return direction === 'row' && 'margin-right: 120px;';
});
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "IrSiteMap__StyledLink",
  componentId: "sc-pz1tvd-5"
})(["color:", ";display:block;width:100%;&:hover{text-decoration:underline;color:", ";}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
;// CONCATENATED MODULE: ./src/components/enlayouts/SiteMap/IrSiteMapLink/index.tsx





var IrSiteMapLink = function IrSiteMapLink() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SiteMapList, {
      minHeight: "regular",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_MANAGE_ROUTE.path */.Xp.path,
          name: enroutes/* IR_MANAGE_ROUTE.name */.Xp.name
        },
        subdirectories: enroutes/* IR_MANAGE_ROUTE.subdirectories */.Xp.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_GOVERNANCE_ROUTE.path */.by.path,
          name: enroutes/* IR_GOVERNANCE_ROUTE.name */.by.name
        },
        subdirectories: enroutes/* IR_GOVERNANCE_ROUTE.subdirectories */.by.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_FINANCIAL_ROUTE.path */.Oh.path,
          name: enroutes/* IR_FINANCIAL_ROUTE.name */.Oh.name
        },
        subdirectories: enroutes/* IR_FINANCIAL_ROUTE.subdirectories */.Oh.subdirectories
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SiteMapList, {
      minHeight: "high",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_LIBRARY_ROUTE.path */.C_.path,
          name: enroutes/* IR_LIBRARY_ROUTE.name */.C_.name
        },
        subdirectories: enroutes/* IR_LIBRARY_ROUTE.subdirectories */.C_.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_STOCK_ROUTE.path */.aQ.path,
          name: enroutes/* IR_STOCK_ROUTE.name */.aQ.name
        },
        subdirectories: enroutes/* IR_STOCK_ROUTE.subdirectories */.aQ.subdirectories
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
      parent: {
        name: enroutes/* IR_OTHER_ROUTE.name */.yE.name
      },
      subdirectories: enroutes/* IR_OTHER_ROUTE.subdirectories */.yE.subdirectories,
      isLast: true
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMapLink__Wrapper",
  componentId: "sc-wp9cdp-0"
})(["display:flex;flex-direction:column;gap:46px;@media screen and (max-width:1047px){gap:14px;}"]);
var SiteMapList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMapLink__SiteMapList",
  componentId: "sc-wp9cdp-1"
})(["display:flex;gap:46px;height:100%;@media screen and (max-width:1047px){flex:1;flex-direction:column;gap:14px;}"]);
;// CONCATENATED MODULE: ./src/components/enlayouts/Ir/Footer.tsx





var Footer = function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* DHeading */.ac, {
      children: "IR Site Map"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 60
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMapLink, {})]
  });
};
;// CONCATENATED MODULE: ./src/components/enlayouts/Ir/index.tsx





var Layout = function Layout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 140
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
};
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__Container",
  componentId: "sc-baigr5-0"
})(["width:1040px;margin:94px auto 130px;@media screen and (max-width:1047px){margin:40px auto 120px;width:100%;padding:0 20px;}"]);

/***/ }),

/***/ 79991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ChartPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Financial/Chart/index.tsx





function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var downloadPath = '//irpocket.com/141A/chart__ver2_hc6/data_en.xlsx';
var chartStylesheet = '//irpocket.com/141A/chart_ver2_hc6/chart_en.css';
var jqueryScript = '//ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js';
var chartFontFamily = '"Noto Sans JP", Arial, sans-serif';
var chartFontOverrideId = 'chart-font-scope-override'; // chart.css sets `font-family` on almost every tag with `!important`. The
// Highcharts graph itself already gets the site font forced back on via
// inline styles in installHighchartsChartFontPatch, so nothing on this page
// is meant to render in the vendor font — re-assert the site font globally
// with a higher-specificity selector (wins regardless of load order).

var installChartFontScopeOverride = function installChartFontScopeOverride() {
  if (document.getElementById(chartFontOverrideId)) return;
  var style = document.createElement('style');
  style.id = chartFontOverrideId;
  style.textContent = "*:not(#__chart_font_scope_never_matches__) { font-family: ".concat(chartFontFamily, " !important; }");
  document.head.appendChild(style);
};

var chartScripts = ['//irpocket.com/141A/chart_ver2_hc6/exporting.js', '//irpocket.com/141A/chart_ver2_hc6/data_en.js', '//irpocket.com/141A/chart_ver2_hc6/data2_en.js', '//irpocket.com/141A/chart_ver2_hc6/data3_en.js', '//irpocket.com/141A/chart_ver2_hc6/data4_en.js', '//irpocket.com/141A/chart_ver2_hc6/data5_en.js', '//irpocket.com/141A/chart_ver2_hc6/data6_en.js', '//irpocket.com/141A/chart_ver2_hc6/data7_en.js', '//irpocket.com/141A/chart_ver2_hc6/data8_en.js', '//irpocket.com/141A/chart_ver2_hc6/add-select-term.js', '//irpocket.com/141A/chart_ver2_hc6/main_en.js'];
var defaultButtons = [{
  value: '-5',
  label: 'latest 5 years'
}, {
  value: '-12',
  label: 'All'
}];
var defaultGraphLabel = 'Chart';
var chartSections = [{
  id: 'newest',
  tabLabel: 'Financial Performance',
  title: 'Financial Performance',
  graphLabel: defaultGraphLabel,
  graphId: 'graph-newest',
  checkId: 'graph-newest-check',
  sourceGlobal: 'source',
  categoriesGlobal: 'mcategories',
  initialDataKey: 'gyouseki',
  buttons: [{
    value: '-3',
    label: 'latest 3 years'
  }, {
    value: '-5',
    label: 'latest 5 years'
  }, {
    value: '-10',
    label: 'All'
  }]
}, {
  id: 'zaimu',
  tabLabel: 'Financial Position',
  title: 'Financial Position',
  graphLabel: defaultGraphLabel,
  graphId: 'graph-zaimu',
  checkId: 'graph-zaimu-check',
  sourceGlobal: 'zsource',
  categoriesGlobal: 'zmcategories',
  initialDataKey: 'zaimu',
  buttons: defaultButtons
}, {
  id: 'cf',
  tabLabel: 'Cash Flow',
  title: 'Cash Flow',
  graphLabel: defaultGraphLabel,
  graphId: 'graph-cf',
  checkId: 'graph-cf-check',
  sourceGlobal: 'cfsource',
  categoriesGlobal: 'cfmcategories',
  initialDataKey: 'cf',
  buttons: defaultButtons
}, {
  id: 'per',
  tabLabel: 'Per Share Data / Dividends',
  title: 'Per Share Data / Dividends',
  graphLabel: defaultGraphLabel,
  graphId: 'graph-per',
  checkId: 'graph-per-check',
  sourceGlobal: 'psource',
  categoriesGlobal: 'pmcategories',
  initialDataKey: 'per',
  buttons: defaultButtons
}, {
  id: 'share',
  tabLabel: 'Stock Metrics',
  title: 'Stock Metrics',
  graphLabel: defaultGraphLabel,
  graphId: 'graph-share',
  checkId: 'graph-share-check',
  sourceGlobal: 'shsource',
  categoriesGlobal: 'shmcategories',
  initialDataKey: 'share',
  buttons: defaultButtons
}, {
  id: 'store',
  tabLabel: 'Number of Stores',
  title: 'Number of Stores',
  graphLabel: defaultGraphLabel,
  graphId: 'graph-store',
  checkId: 'graph-store-check',
  sourceGlobal: 'stsource',
  categoriesGlobal: 'stmcategories',
  initialDataKey: 'store',
  buttons: defaultButtons
}, {
  id: 'trialseiyu',
  tabLabel: 'TRIAL / SEIYU',
  title: 'TRIAL / SEIYU',
  graphLabel: defaultGraphLabel,
  graphId: 'graph-trialseiyu',
  checkId: 'graph-trialseiyu-check',
  sourceGlobal: 'tsource',
  categoriesGlobal: 'tmcategories',
  initialDataKey: 'trialseiyu',
  buttons: defaultButtons
}, {
  id: 'cate',
  tabLabel: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: ["Net Sales by ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Product Category"]
  }),
  title: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: ["Net Sales by ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Product Category"]
  }),
  graphLabel: defaultGraphLabel,
  graphId: 'graph-cate',
  checkId: 'graph-cate-check',
  sourceGlobal: 'csource',
  categoriesGlobal: 'cmcategories',
  initialDataKey: 'cate',
  buttons: defaultButtons,
  hasCategoryNav: true
}];

var description = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
  children: ["You can view it in different ways, such as a graph display or a table display where you can download just the data.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "You can also display numerical values just by clicking on the graph. You can also select the number of indicators, so please take advantage of it."]
});

var isChartTarget = function isChartTarget(target) {
  return target !== null;
};

var isStringArray = function isStringArray(value) {
  return Array.isArray(value) && value.every(function (item) {
    return typeof item === 'string';
  });
};

var isRecord = function isRecord(value) {
  return typeof value === 'object' && value !== null;
};

var getChartRenderToId = function getChartRenderToId(chart) {
  var _chart$renderTo, _chart$options, _chart$options$chart;

  if ((_chart$renderTo = chart.renderTo) !== null && _chart$renderTo !== void 0 && _chart$renderTo.id) return chart.renderTo.id;
  var renderTo = (_chart$options = chart.options) === null || _chart$options === void 0 ? void 0 : (_chart$options$chart = _chart$options.chart) === null || _chart$options$chart === void 0 ? void 0 : _chart$options$chart.renderTo;
  if (typeof renderTo === 'string') return renderTo;
  if (renderTo instanceof HTMLElement) return renderTo.id;
  return null;
};

var withChartFontStyle = function withChartFontStyle(style) {
  return _objectSpread(_objectSpread({}, isRecord(style) ? style : {}), {}, {
    fontFamily: chartFontFamily,
    fontWeight: 'normal'
  });
};

var withChartAxisFont = function withChartAxisFont(axis) {
  if (Array.isArray(axis)) return axis.map(withChartAxisFont);
  if (!isRecord(axis)) return axis;
  var labels = isRecord(axis.labels) ? axis.labels : {};
  return _objectSpread(_objectSpread({}, axis), {}, {
    labels: _objectSpread(_objectSpread({}, labels), {}, {
      style: withChartFontStyle(labels.style)
    })
  });
};

var MEASURE_CANVAS = typeof document !== 'undefined' ? document.createElement('canvas') : null;

var measureItemWidth = function measureItemWidth(name) {
  var ctx = MEASURE_CANVAS === null || MEASURE_CANVAS === void 0 ? void 0 : MEASURE_CANVAS.getContext('2d');
  if (!ctx) return 0;
  ctx.font = "12px ".concat(chartFontFamily);
  return ctx.measureText(name).width;
};

var alignLegendItems = function alignLegendItems(chartInstance) {
  try {
    var _legend$options2;

    var _chart = chartInstance;
    var legend = _chart.legend;
    var allItems = legend === null || legend === void 0 ? void 0 : legend.allItems;
    if (!(allItems !== null && allItems !== void 0 && allItems.length)) return;
    var isSP =  true && window.innerWidth < 768;

    if (isSP) {
      var _legend$options;

      // On SP, force a single column by setting itemWidth wide enough
      // that items can't fit side-by-side → they stack vertically.
      var chartWidth = _chart.chartWidth || 0;

      var _itemWidth = chartWidth > 0 ? chartWidth - 40 : 300;

      var _currentWidth = legend === null || legend === void 0 ? void 0 : (_legend$options = legend.options) === null || _legend$options === void 0 ? void 0 : _legend$options.itemWidth;

      if (typeof _currentWidth === 'number' && _currentWidth === _itemWidth) return;
      var _update = _chart.update;
      _update === null || _update === void 0 ? void 0 : _update.call(_chart, {
        legend: {
          itemWidth: _itemWidth
        }
      }, true, false, false);
      return;
    } // PC: align columns using Canvas measureText (sync, no font-loading race)


    var maxWidth = 0;
    allItems.forEach(function (item) {
      var name = item.name;

      if (name) {
        var w = measureItemWidth(name);
        if (w > maxWidth) maxWidth = w;
      }
    });
    if (maxWidth <= 0) return; // 14 = icon width, 8 = gap between icon and text, 12 = padding

    var itemWidth = Math.ceil(maxWidth) + 14 + 8 + 12;
    var availableWidth = _chart.plotWidth || _chart.chartWidth || 0; // If the longest item is wider than half the chart width it can't fit.

    if (availableWidth > 0 && itemWidth > availableWidth / 2) return;
    var currentWidth = legend === null || legend === void 0 ? void 0 : (_legend$options2 = legend.options) === null || _legend$options2 === void 0 ? void 0 : _legend$options2.itemWidth;
    if (typeof currentWidth === 'number' && currentWidth === itemWidth) return;
    var update = _chart.update;
    update === null || update === void 0 ? void 0 : update.call(_chart, {
      legend: {
        itemWidth: itemWidth
      }
    }, true, false, false);
  } catch (_) {
    /* ignore */
  }
};

var withChartFontOptions = function withChartFontOptions(options) {
  var chart = isRecord(options.chart) ? options.chart : {};
  var legend = isRecord(options.legend) ? options.legend : {};
  var chartEvents = isRecord(chart.events) ? chart.events : {};
  var originalLoad = typeof chartEvents.load === 'function' ? chartEvents.load : undefined;
  var originalRedraw = typeof chartEvents.redraw === 'function' ? chartEvents.redraw : undefined;
  return _objectSpread(_objectSpread({}, options), {}, {
    chart: _objectSpread(_objectSpread({}, chart), {}, {
      style: withChartFontStyle(chart.style),
      events: _objectSpread(_objectSpread({}, chartEvents), {}, {
        load: function load() {
          if (originalLoad) originalLoad.call(this); // Noto Sans JP font width differs from browser default,
          // so recalculate legend itemWidth after font patch takes effect.

          alignLegendItems(this);
        },
        redraw: function redraw() {
          if (originalRedraw) originalRedraw.call(this); // Recalculate on resize (PC↔SP) — value comparison inside
          // prevents infinite loop when alignment itself triggers redraw.

          alignLegendItems(this);
        }
      })
    }),
    legend: _objectSpread(_objectSpread({}, legend), {}, {
      itemStyle: withChartFontStyle(legend.itemStyle)
    }),
    xAxis: withChartAxisFont(options.xAxis),
    yAxis: withChartAxisFont(options.yAxis)
  });
};

var installHighchartsChartFontPatch = function installHighchartsChartFontPatch() {
  var highcharts = window.Highcharts;
  var OriginalChart = highcharts === null || highcharts === void 0 ? void 0 : highcharts.Chart;

  if (!highcharts || !OriginalChart || highcharts.chartFontPatchInstalled) {
    return;
  }

  var PatchedChart = function PatchedChart(options) {
    return new OriginalChart(withChartFontOptions(options));
  };

  PatchedChart.prototype = OriginalChart.prototype;
  highcharts.Chart = PatchedChart;
  highcharts.chartFontPatchInstalled = true;
};

var handleActionAnchorKeyDown = function handleActionAnchorKeyDown(event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  event.currentTarget.click();
};

var handlePrintClick = function handlePrintClick(event) {
  if (event.defaultPrevented) return;
  event.preventDefault();
  window.print();
};

var reflowPanelCharts = function reflowPanelCharts(panel) {
  var _highcharts$charts;

  var highcharts = window.Highcharts;
  highcharts === null || highcharts === void 0 ? void 0 : (_highcharts$charts = highcharts.charts) === null || _highcharts$charts === void 0 ? void 0 : _highcharts$charts.forEach(function (chart) {
    var _chart$reflow, _chart$redraw;

    if (!(chart !== null && chart !== void 0 && chart.renderTo) || !panel.contains(chart.renderTo)) return;
    (_chart$reflow = chart.reflow) === null || _chart$reflow === void 0 ? void 0 : _chart$reflow.call(chart);
    (_chart$redraw = chart.redraw) === null || _chart$redraw === void 0 ? void 0 : _chart$redraw.call(chart);
  });
};

var handleChartModeClick = function handleChartModeClick(event, mode) {
  event.preventDefault();
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation();
  var panel = event.currentTarget.closest('dd');
  if (!panel) return;
  panel.querySelectorAll('.graph-container').forEach(function (element) {
    element.style.display = mode === 'graph' ? '' : 'none';
  });
  panel.querySelectorAll('.table-container').forEach(function (element) {
    element.style.display = mode === 'table' ? '' : 'none';
  });
  panel.querySelectorAll('.chartable li').forEach(function (item) {
    item.classList.toggle('active', item.contains(event.currentTarget));
  });
  panel.querySelectorAll('.chartable a').forEach(function (anchor) {
    anchor.classList.toggle('active', anchor === event.currentTarget);
  });

  if (mode === 'graph') {
    window.requestAnimationFrame(function () {
      var _highcharts$charts2;

      if (panel.id === 'cate') {
        updateCategoryChart(getCategoryDataKey(panel));
      } // table→graph: restore all hidden series and reflow


      var highcharts = window.Highcharts;
      highcharts === null || highcharts === void 0 ? void 0 : (_highcharts$charts2 = highcharts.charts) === null || _highcharts$charts2 === void 0 ? void 0 : _highcharts$charts2.forEach(function (chart) {
        var _chart$series;

        if (!(chart !== null && chart !== void 0 && chart.renderTo) || !panel.contains(chart.renderTo)) return;
        (_chart$series = chart.series) === null || _chart$series === void 0 ? void 0 : _chart$series.forEach(function (series) {
          var _series$setVisible;

          if ((series === null || series === void 0 ? void 0 : series.visible) === false) (_series$setVisible = series.setVisible) === null || _series$setVisible === void 0 ? void 0 : _series$setVisible.call(series, true, false);
        });
      });
      reflowPanelCharts(panel);
    });
  }
};

var isChartSource = function isChartSource(value) {
  return isRecord(value);
};

var getCategoryRuntime = function getCategoryRuntime() {
  var chartWindow = window;
  var source = chartWindow.csource;
  var categories = chartWindow.cmcategories;
  if (!isChartSource(source) || !isStringArray(categories)) return null;
  return {
    chartWindow: chartWindow,
    source: source,
    categories: categories
  };
};

var getCategoryDataKey = function getCategoryDataKey(panel) {
  return panel.dataset.categoryDataKey === 'seiyu' ? 'seiyu' : 'cate';
};

var addCommas = function addCommas(value) {
  if (!value) return '';

  var _String$split = String(value).split('.'),
      _String$split2 = (0,slicedToArray/* default */.Z)(_String$split, 2),
      integerPart = _String$split2[0],
      decimalPart = _String$split2[1];

  var formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimalPart ? "".concat(formattedInteger, ".").concat(decimalPart) : formattedInteger;
};

var getSelectedPeriodIndexes = function getSelectedPeriodIndexes(checkContainer, categories) {
  return Array.from(checkContainer.querySelectorAll('.cselect:checked')).map(function (input) {
    return Number(input.value);
  }).filter(function (index) {
    return Number.isInteger(index) && index >= 0 && index < categories.length;
  });
};

var getCategoryChart = function getCategoryChart() {
  var _highcharts$charts3;

  var highcharts = window.Highcharts;
  return highcharts === null || highcharts === void 0 ? void 0 : (_highcharts$charts3 = highcharts.charts) === null || _highcharts$charts3 === void 0 ? void 0 : _highcharts$charts3.slice().reverse().find(function (chart) {
    var _chart$renderTo2;

    return !!chart && !chart.destroyed && !!((_chart$renderTo2 = chart.renderTo) !== null && _chart$renderTo2 !== void 0 && _chart$renderTo2.isConnected) && getChartRenderToId(chart) === 'graph-cate';
  });
};

var renderCategoryTable = function renderCategoryTable(panel, dataset, selectedCategories, tableRows) {
  var tableContainer = panel.querySelector('.table');
  if (!tableContainer) return;
  var table = document.createElement('table');
  var thead = document.createElement('thead');
  var tbody = document.createElement('tbody');
  var headRow = document.createElement('tr');
  headRow.appendChild(document.createElement('th'));
  selectedCategories.forEach(function (category) {
    var th = document.createElement('th');
    th.textContent = category;
    headRow.appendChild(th);
  });
  dataset.indexes.forEach(function (_ref, rowIndex) {
    var _tableRows$rowIndex;

    var name = _ref.name;
    var row = document.createElement('tr');
    var th = document.createElement('th');
    th.textContent = name;
    row.appendChild(th);
    (_tableRows$rowIndex = tableRows[rowIndex]) === null || _tableRows$rowIndex === void 0 ? void 0 : _tableRows$rowIndex.forEach(function (value) {
      var td = document.createElement('td');
      td.textContent = addCommas(value);
      row.appendChild(td);
    });
    tbody.appendChild(row);
  });
  thead.appendChild(headRow);
  table.append(thead, tbody);
  tableContainer.replaceChildren(table);
};

var updateCategoryHighcharts = function updateCategoryHighcharts(dataset, selectedCategories, seriesData) {
  var _chart$update, _dataset$height, _chart$xAxis, _chart$xAxis$, _chart$xAxis$$setCate, _chart$xAxis2, _chart$xAxis2$, _chart$xAxis2$$update, _chart$yAxis, _chart$yAxis$, _chart$yAxis$$update, _dataset$min, _dataset$max, _dataset$span, _dataset$unit, _chart$yAxis2, _chart$yAxis2$, _chart$yAxis2$$update, _dataset$min2, _dataset$max2, _dataset$span2, _dataset$unit2, _chart$redraw2, _chart$reflow2;

  var chart = getCategoryChart();
  if (!chart) return false;
  (_chart$update = chart.update) === null || _chart$update === void 0 ? void 0 : _chart$update.call(chart, {
    chart: {
      height: (_dataset$height = dataset.height) !== null && _dataset$height !== void 0 ? _dataset$height : 500
    },
    plotOptions: {
      series: {
        stacking: dataset.stack ? 'normal' : null
      }
    }
  }, false, false, false);
  (_chart$xAxis = chart.xAxis) === null || _chart$xAxis === void 0 ? void 0 : (_chart$xAxis$ = _chart$xAxis[0]) === null || _chart$xAxis$ === void 0 ? void 0 : (_chart$xAxis$$setCate = _chart$xAxis$.setCategories) === null || _chart$xAxis$$setCate === void 0 ? void 0 : _chart$xAxis$$setCate.call(_chart$xAxis$, selectedCategories, false);
  (_chart$xAxis2 = chart.xAxis) === null || _chart$xAxis2 === void 0 ? void 0 : (_chart$xAxis2$ = _chart$xAxis2[0]) === null || _chart$xAxis2$ === void 0 ? void 0 : (_chart$xAxis2$$update = _chart$xAxis2$.update) === null || _chart$xAxis2$$update === void 0 ? void 0 : _chart$xAxis2$$update.call(_chart$xAxis2$, {
    categories: selectedCategories
  }, false);
  (_chart$yAxis = chart.yAxis) === null || _chart$yAxis === void 0 ? void 0 : (_chart$yAxis$ = _chart$yAxis[0]) === null || _chart$yAxis$ === void 0 ? void 0 : (_chart$yAxis$$update = _chart$yAxis$.update) === null || _chart$yAxis$$update === void 0 ? void 0 : _chart$yAxis$$update.call(_chart$yAxis$, {
    min: (_dataset$min = dataset.min) !== null && _dataset$min !== void 0 ? _dataset$min : null,
    max: (_dataset$max = dataset.max) !== null && _dataset$max !== void 0 ? _dataset$max : null,
    tickInterval: (_dataset$span = dataset.span) !== null && _dataset$span !== void 0 ? _dataset$span : null,
    title: {
      y: -20,
      x: 30,
      align: 'high',
      rotation: 0,
      text: (_dataset$unit = dataset.unit) !== null && _dataset$unit !== void 0 ? _dataset$unit : ''
    }
  }, false);
  (_chart$yAxis2 = chart.yAxis) === null || _chart$yAxis2 === void 0 ? void 0 : (_chart$yAxis2$ = _chart$yAxis2[1]) === null || _chart$yAxis2$ === void 0 ? void 0 : (_chart$yAxis2$$update = _chart$yAxis2$.update) === null || _chart$yAxis2$$update === void 0 ? void 0 : _chart$yAxis2$$update.call(_chart$yAxis2$, {
    min: (_dataset$min2 = dataset.min2) !== null && _dataset$min2 !== void 0 ? _dataset$min2 : null,
    max: (_dataset$max2 = dataset.max2) !== null && _dataset$max2 !== void 0 ? _dataset$max2 : null,
    tickInterval: (_dataset$span2 = dataset.span2) !== null && _dataset$span2 !== void 0 ? _dataset$span2 : null,
    title: {
      y: -20,
      x: 20,
      align: 'high',
      rotation: 0,
      text: (_dataset$unit2 = dataset.unit2) !== null && _dataset$unit2 !== void 0 ? _dataset$unit2 : ''
    }
  }, false);
  seriesData.forEach(function (data, index) {
    var _chart$series2, _chart$series2$index, _chart$series2$index$;

    var chartIndex = dataset.indexes[index];
    if (!chartIndex) return;
    (_chart$series2 = chart.series) === null || _chart$series2 === void 0 ? void 0 : (_chart$series2$index = _chart$series2[index]) === null || _chart$series2$index === void 0 ? void 0 : (_chart$series2$index$ = _chart$series2$index.update) === null || _chart$series2$index$ === void 0 ? void 0 : _chart$series2$index$.call(_chart$series2$index, {
      data: data,
      name: chartIndex.name,
      type: chartIndex.type,
      color: chartIndex.color,
      yAxis: chartIndex.type === 'column' || chartIndex.yAxis === 0 ? 0 : 1
    }, false);
  });
  (_chart$redraw2 = chart.redraw) === null || _chart$redraw2 === void 0 ? void 0 : _chart$redraw2.call(chart);
  (_chart$reflow2 = chart.reflow) === null || _chart$reflow2 === void 0 ? void 0 : _chart$reflow2.call(chart);
  return true;
};

var updateCategoryChart = function updateCategoryChart(dataKey) {
  var runtime = getCategoryRuntime();
  var panel = document.getElementById('cate');
  var checkContainer = document.getElementById('graph-cate-check');
  if (!runtime || !panel || !checkContainer) return;
  var chartWindow = runtime.chartWindow,
      source = runtime.source,
      categories = runtime.categories;
  var dataset = source[dataKey];
  if (!dataset) return;
  panel.dataset.categoryDataKey = dataKey;
  renderPeriodCheckboxes(checkContainer, categories);
  panel.querySelectorAll('#nav a.menu').forEach(function (anchor) {
    anchor.classList.toggle('active', anchor.getAttribute('href') === "#".concat(dataKey));
  });
  var selectedIndexes = getSelectedPeriodIndexes(checkContainer, categories);
  var selectedCategories = selectedIndexes.map(function (index) {
    return categories[index];
  });
  var seriesData = dataset.master.map(function (row) {
    return selectedIndexes.map(function (index) {
      var value = parseFloat(String(row[index]));
      return Number.isNaN(value) ? null : value;
    });
  });
  var tableRows = dataset.master.map(function (row) {
    return selectedIndexes.map(function (index) {
      return row[index];
    });
  });
  var title = panel.querySelector('.title');
  if (title) title.textContent = dataset.title;
  panel.querySelectorAll('.note').forEach(function (note) {
    var _dataset$note;

    note.innerHTML = (_dataset$note = dataset.note) !== null && _dataset$note !== void 0 ? _dataset$note : '';
  });
  panel.querySelectorAll('.graph').forEach(function (graph) {
    var _dataset$height2;

    graph.style.height = "".concat((_dataset$height2 = dataset.height) !== null && _dataset$height2 !== void 0 ? _dataset$height2 : 440, "px");
  });
  renderCategoryTable(panel, dataset, selectedCategories, tableRows);
  if (updateCategoryHighcharts(dataset, selectedCategories, seriesData)) return;
  var graph = document.getElementById('graph-cate');

  if (graph && !graph.querySelector('.highcharts-container') && chartWindow.runChart && chartWindow.jQuery) {
    chartWindow.runChart(undefined, chartWindow.jQuery(panel), source, categories, 'graph-cate', dataKey);
  }
};

var handleCategoryNavClick = function handleCategoryNavClick(event, dataKey) {
  event.preventDefault();
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation();
  updateCategoryChart(dataKey);
};

var handleCategoryPeriodClick = function handleCategoryPeriodClick(event) {
  var target = event.target;
  var button = target.closest('input.clast');
  if (!button) return;
  var panel = button.closest('dd');
  var checkContainer = button.closest('.check-container');
  if ((panel === null || panel === void 0 ? void 0 : panel.id) !== 'cate' || !checkContainer) return;
  event.preventDefault();
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation();
  var last = Number(button.dataset.val);
  var checkboxes = Array.from(checkContainer.querySelectorAll('input[type="checkbox"]'));
  checkboxes.forEach(function (checkbox, index) {
    checkbox.checked = !(checkboxes.length + last > index);
  });
  updateCategoryChart(getCategoryDataKey(panel));
};

var handleCategoryPeriodChange = function handleCategoryPeriodChange(event) {
  var target = event.target;
  var checkbox = target.closest('input.cselect');
  if (!checkbox) return;
  var panel = checkbox.closest('dd');
  if ((panel === null || panel === void 0 ? void 0 : panel.id) !== 'cate') return;
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation();
  updateCategoryChart(getCategoryDataKey(panel));
};

var handleCategoryPeriodNativeClick = function handleCategoryPeriodNativeClick(event) {
  var target = event.target;
  if (!(target instanceof HTMLElement)) return;
  var button = target.closest('#graph-cate-check input.clast');
  if (!button) return;
  var panel = button.closest('dd');
  var checkContainer = button.closest('.check-container');
  if ((panel === null || panel === void 0 ? void 0 : panel.id) !== 'cate' || !checkContainer) return;
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  var last = Number(button.dataset.val);
  var checkboxes = Array.from(checkContainer.querySelectorAll('input[type="checkbox"]'));
  checkboxes.forEach(function (checkbox, index) {
    checkbox.checked = !(checkboxes.length + last > index);
  });
  updateCategoryChart(getCategoryDataKey(panel));
};

var handleCategoryPeriodNativeChange = function handleCategoryPeriodNativeChange(event) {
  var target = event.target;
  if (!(target instanceof HTMLElement)) return;
  var checkbox = target.closest('#graph-cate-check input.cselect');
  if (!checkbox) return;
  var panel = checkbox.closest('dd');
  if ((panel === null || panel === void 0 ? void 0 : panel.id) !== 'cate') return;
  event.stopPropagation();
  event.stopImmediatePropagation();
  updateCategoryChart(getCategoryDataKey(panel));
};

var installCategoryPeriodEventGuard = function installCategoryPeriodEventGuard() {
  document.addEventListener('click', handleCategoryPeriodNativeClick, true);
  document.addEventListener('change', handleCategoryPeriodNativeChange, true);
  return function () {
    document.removeEventListener('click', handleCategoryPeriodNativeClick, true);
    document.removeEventListener('change', handleCategoryPeriodNativeChange, true);
  };
};

var renderPeriodCheckboxes = function renderPeriodCheckboxes(checkContainer, categories) {
  if (checkContainer.querySelector('.cselect')) return;
  var fragment = document.createDocumentFragment();
  categories.forEach(function (category, index) {
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.dataset.val = category;
    input.value = String(index);
    input.checked = true;
    input.name = "c".concat(category);
    input.id = "c".concat(category);
    input.className = 'cselect';
    var label = document.createElement('label');
    label.htmlFor = input.id;
    label.textContent = category;
    fragment.append(input, label);
  });
  checkContainer.insertBefore(fragment, checkContainer.firstChild);
};

var initializeChartBindings = function initializeChartBindings() {
  var chartWindow = window;
  var jQuery = chartWindow.jQuery,
      runChart = chartWindow.runChart;
  if (!jQuery || !runChart) return false;
  var chartTargets = chartSections.map(function (section) {
    var panel = document.getElementById(section.id);
    var graph = document.getElementById(section.graphId);
    var checkContainer = document.getElementById(section.checkId);
    var source = chartWindow[section.sourceGlobal];
    var categories = chartWindow[section.categoriesGlobal];

    if (!panel || !graph || !checkContainer || !source || !isStringArray(categories)) {
      return null;
    }

    return _objectSpread(_objectSpread({}, section), {}, {
      panel: panel,
      graph: graph,
      checkContainer: checkContainer,
      source: source,
      categories: categories
    });
  });
  if (chartTargets.some(function (target) {
    return target === null;
  })) return false;
  var targets = chartTargets.filter(isChartTarget); // Only generate period checkboxes. Chart rendering and tab switching are
  // handled by main.js $(document).ready and jQuery handlers.

  targets.forEach(function (_ref2) {
    var checkContainer = _ref2.checkContainer,
        categories = _ref2.categories;
    renderPeriodCheckboxes(checkContainer, categories);
  });
  return true;
};

var handleChartTabClick = function handleChartTabClick(event, _id) {
  // prevent hash navigation only; tab switching handled by main.js jQuery handler
  event.preventDefault();
};

var useChartScripts = function useChartScripts() {
  (0,react.useEffect)(function () {
    if (false) {}
    var isCancelled = false;
    var pendingTimeouts = [];

    var clearEmptyHash = function clearEmptyHash() {
      var hasEmptyHash = window.location.hash === '#' || window.location.hash === '' && window.location.href.endsWith('#');
      if (!hasEmptyHash) return;
      window.history.replaceState(null, '', "".concat(window.location.pathname).concat(window.location.search));
    };

    clearEmptyHash();
    window.addEventListener('hashchange', clearEmptyHash);
    var cleanupCategoryPeriodEventGuard = installCategoryPeriodEventGuard();

    var scheduleChartBindingInitialization = function scheduleChartBindingInitialization() {
      var attemptCount = 0;
      var maxAttemptCount = 10;

      var tryInitialize = function tryInitialize() {
        if (isCancelled) return;
        attemptCount += 1;
        if (initializeChartBindings() || attemptCount >= maxAttemptCount) return;
        pendingTimeouts.push(window.setTimeout(tryInitialize, 50));
      };

      pendingTimeouts.push(window.setTimeout(tryInitialize, 100));
    };

    var loadScript = function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var existingScript = document.querySelector("script[data-chart-script=\"".concat(src, "\"]"));

        if (existingScript) {
          if (existingScript.dataset.loaded === 'true') {
            resolve();
            return;
          }

          existingScript.addEventListener('load', function () {
            return resolve();
          }, {
            once: true
          });
          existingScript.addEventListener('error', function () {
            return reject(new Error("Failed to load ".concat(src)));
          }, {
            once: true
          });
          return;
        }

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.async = false;
        script.dataset.chartScript = src;

        script.onload = function () {
          script.dataset.loaded = 'true';
          resolve();
        };

        script.onerror = function () {
          return reject(new Error("Failed to load ".concat(src)));
        };

        document.body.appendChild(script);
      });
    };

    var loadStylesheet = function loadStylesheet(href) {
      return new Promise(function (resolve, reject) {
        var existingLink = document.querySelector("link[rel=\"stylesheet\"][data-chart-stylesheet=\"".concat(href, "\"], link[rel=\"stylesheet\"][href=\"").concat(href, "\"]"));

        if (existingLink) {
          existingLink.dataset.loaded = 'true';
          resolve();
          return;
        }

        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.dataset.chartStylesheet = href;

        link.onload = function () {
          link.dataset.loaded = 'true';
          resolve();
        };

        link.onerror = function () {
          return reject(new Error("Failed to load ".concat(href)));
        };

        document.body.appendChild(link);
      });
    }; // main.js jQuery handlers don't trigger reflow after tab switch.
    // Use a native delegated handler to call reflowPanelCharts with double RAF
    // after jQuery finishes showing/hiding panels.


    var tabEl = document.querySelector('.tab');

    var handleTabReflow = function handleTabReflow(e) {
      var _anchor$getAttribute;

      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      var id = (_anchor$getAttribute = anchor.getAttribute('href')) === null || _anchor$getAttribute === void 0 ? void 0 : _anchor$getAttribute.slice(1);
      if (!id) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var panel = document.getElementById(id);
          if (panel) reflowPanelCharts(panel);
        });
      });
    };

    tabEl === null || tabEl === void 0 ? void 0 : tabEl.addEventListener('click', handleTabReflow);

    var loadScripts = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _iterator, _step, src;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loadScript(jqueryScript);

              case 2:
                if (!isCancelled) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return loadStylesheet(chartStylesheet);

              case 6:
                installChartFontScopeOverride();
                _iterator = _createForOfIteratorHelper(chartScripts);
                _context.prev = 8;

                _iterator.s();

              case 10:
                if ((_step = _iterator.n()).done) {
                  _context.next = 18;
                  break;
                }

                src = _step.value;

                if (!isCancelled) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return");

              case 14:
                _context.next = 16;
                return loadScript(src);

              case 16:
                _context.next = 10;
                break;

              case 18:
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](8);

                _iterator.e(_context.t0);

              case 23:
                _context.prev = 23;

                _iterator.f();

                return _context.finish(23);

              case 26:
                // Highcharts loaded globally via _document.tsx — apply font patch now
                installHighchartsChartFontPatch();
                scheduleChartBindingInitialization();

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 20, 23, 26]]);
      }));

      return function loadScripts() {
        return _ref3.apply(this, arguments);
      };
    }();

    loadScripts()["catch"](function (error) {
      console.error(error);
    });
    return function () {
      var _document$getElementB;

      isCancelled = true;
      pendingTimeouts.forEach(function (timeoutId) {
        return window.clearTimeout(timeoutId);
      });
      tabEl === null || tabEl === void 0 ? void 0 : tabEl.removeEventListener('click', handleTabReflow);
      window.removeEventListener('hashchange', clearEmptyHash);
      cleanupCategoryPeriodEventGuard(); // Prevent this page's global font-family override from leaking into
      // other pages after client-side navigation away from here.

      document.querySelectorAll("link[data-chart-stylesheet=\"".concat(chartStylesheet, "\"]")).forEach(function (link) {
        return link.remove();
      });
      (_document$getElementB = document.getElementById(chartFontOverrideId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.remove();
    };
  }, []);
};

var IrpNoticeLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Chart__IrpNoticeLink",
  componentId: "sc-1as8b3w-0"
})(["&:hover{text-decoration:underline;color:", ";}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);

var ChartToolbar = function ChartToolbar(_ref4) {
  var graphLabel = _ref4.graphLabel;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    id: "",
    className: "buttons",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-left",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "chartable",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "active",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "show-graph",
            role: "button",
            tabIndex: 0,
            onClickCapture: function onClickCapture(event) {
              return handleChartModeClick(event, 'graph');
            },
            onKeyDown: handleActionAnchorKeyDown,
            children: graphLabel
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "show-table",
            role: "button",
            tabIndex: 0,
            onClickCapture: function onClickCapture(event) {
              return handleChartModeClick(event, 'table');
            },
            onKeyDown: handleActionAnchorKeyDown,
            children: "Table"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text-right",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "graph-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "print",
              role: "button",
              tabIndex: 0,
              onClick: handlePrintClick,
              onKeyDown: handleActionAnchorKeyDown,
              children: "Print"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            id: "adjst",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: downloadPath,
              children: "Download"
            }), " (", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: downloadPath,
              id: "download",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "xls-download",
              children: "Excel"
            }), ")"]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "table-container",
        style: {
          display: 'none'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "print",
              role: "button",
              tabIndex: 0,
              onClick: handlePrintClick,
              onKeyDown: handleActionAnchorKeyDown,
              children: "Print"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            id: "adjst",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: downloadPath,
              children: "Download"
            }), " (", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: downloadPath,
              id: "download",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "xls-download",
              children: "Excel"
            }), ")"]
          })]
        })
      })]
    })]
  });
};

var CategoryNav = function CategoryNav() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "nav",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: "menu active",
          href: "#cate",
          style: {
            fontWeight: 'bold'
          },
          onClickCapture: function onClickCapture(event) {
            return handleCategoryNavClick(event, 'cate');
          },
          children: "TRIAL"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: "menu",
          href: "#seiyu",
          onClickCapture: function onClickCapture(event) {
            return handleCategoryNavClick(event, 'seiyu');
          },
          children: "SEIYU"
        })
      })]
    })
  });
};

var ChartPanel = function ChartPanel(_ref5) {
  var id = _ref5.id,
      title = _ref5.title,
      graphId = _ref5.graphId,
      checkId = _ref5.checkId,
      buttons = _ref5.buttons,
      graphLabel = _ref5.graphLabel,
      hasCategoryNav = _ref5.hasCategoryNav;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
    id: id,
    className: "jsTabItem".concat(id === 'newest' ? ' active' : ''),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [hasCategoryNav && /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryNav, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ChartToolbar, {
        graphLabel: graphLabel
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "gt-holder",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          id: "desc",
          children: description
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "head-title ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "title".concat(id === 'newest' ? '' : ' h2Tit'),
            children: title
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "graph-container",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "graph",
            id: graphId,
            style: {
              margin: '0 auto'
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "table-container",
          style: {
            height: 'auto',
            margin: '0 auto',
            display: 'none'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "table table-scroll",
            style: {
              margin: 0
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "annotation spOnly",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "number"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "note"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "h3Tit",
        children: "Period"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        id: checkId,
        className: "check-container",
        onClickCapture: id === 'cate' ? handleCategoryPeriodClick : undefined,
        onChangeCapture: id === 'cate' ? handleCategoryPeriodChange : undefined,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "btns",
          style: {
            display: 'none'
          },
          children: buttons.map(function (_ref6) {
            var value = _ref6.value,
                label = _ref6.label;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "button",
              "data-val": value,
              value: label,
              className: "clast"
            }, value);
          })
        }), id !== 'newest' && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          id: "note"
        })]
      })]
    })
  });
};

var ChartPage = function ChartPage() {
  useChartScripts();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        href: "https://irpocket.com"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preload",
        href: chartStylesheet,
        as: "style"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      enTitleText: "Chart Generator",
      subTitleText: "",
      color: "normal"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "jsTabGroup",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "tab col2",
        children: chartSections.map(function (_ref7) {
          var id = _ref7.id,
              tabLabel = _ref7.tabLabel;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: id === 'newest' ? 'active' : undefined,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "#".concat(id),
              className: id === 'newest' ? 'act' : undefined,
              onClick: function onClick(event) {
                return handleChartTabClick(event, id);
              },
              children: tabLabel
            })
          }, id);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        id: "fychart",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          style: {
            display: 'none'
          },
          children: "Chart Generator"
        }), chartSections.map(function (section) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ChartPanel, _objectSpread({}, section), section.id);
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "irp_comment",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IrpNoticeLink, {
        href: "//irpocket.com/notice_en.html",
        target: "_blank",
        rel: "noopener noreferrer",
        children: "About IR site"
      })
    })]
  });
};

ChartPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir'
  }, {
    name: 'Financial Information',
    path: '/en/ir/financial'
  }, {
    name: 'Chart Generator',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Chart Generator",
      description: "The chart generator for financial information.",
      ogp: {
        url: 'en/ir/financial/chart'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/en/ir/financial/chart.tsx


/***/ }),

/***/ 68740:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/financial/chart",
      function () {
        return __webpack_require__(79991);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,2098,9774,2888,179], function() { return __webpack_exec__(68740); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);